<template>
  <mobile-responsive-shell :title="title">
    <desktop-view />
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/stocks/Statistics.vue";

export default {
  name: "MobileStocksStatistics",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Statistiques stock",
    };
  },
};
</script>
